<template>
    <div>
        <app-form-select-input
            label="Seleccione tipo de petición"
            v-model="petition.typePetitionId"
            :options="petitionTypes"
            :hasError="$v.petition.typePetitionId.$error"
            errorMessage="Debe seleccionar el tipo de petición"
            @change="$v.petition.typePetitionId.$touch()"
            :required="true"
        />
        <app-form-textarea-input
            label="Descripción"
            v-model="petition.description"
            :hasError="$v.petition.description.$error"
            errorMessage="Debe especificar su petición"
            :required="true"
        />
        <app-upload-files
            id="petition-files"
            title="Adjunte archivos relacionados a la petición"
            v-model="files"
        ></app-upload-files>
    </div>
</template>
<script>
import petitionsRepository from "../../../repositories/petitions.repository.js";
import { required } from "vuelidate/lib/validators";
import FormTextInput from "../../UI/Controls/Forms/FormTextInput.vue";
import FormSelectInput from "../../UI/Controls/Forms/FormSelectInput.vue";
import FormTextareaInput from "../../UI/Controls/Forms/FormTextareaInput.vue";
import UploadFiles from "../../UI/Controls/Files/UploadFiles.vue";
import { mapGetters } from "vuex";

export default {
    components: {
        appFormTextInput: FormTextInput,
        appFormSelectInput: FormSelectInput,
        appFormTextareaInput: FormTextareaInput,
        appUploadFiles: UploadFiles
    },

    props: {
        onSave: {
            type: Function
        },
        isDirector: {
            type: Boolean,
            default: false
        },
        clientSelected: {
            default: ""
        }
    },

    data() {
        return {
            petition: {
                typePetitionId: "",
                clientId: "",
                userId: "",
                description: ""
            },
            files: ""
        };
    },

    watch: {
        clientSelected(val) {
            this.isDirector
                ? (this.petition.clientId = this.clientSelected)
                : this.client.id;
        }
    },

    validations: {
        petition: {
            typePetitionId: { required },
            description: { required }
        }
    },
    computed: {
        ...mapGetters(["petitionTypes"])
    },
    methods: {
        registerPetition() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                toastr.error(
                    "Debe diligenciar correctamente todos los campos obligatorios"
                );
                return false;
            }

            const formData = new FormData();

            formData.append("typePetitionId", this.petition.typePetitionId);
            formData.append("clientId", this.petition.clientId);
            formData.append("userId", this.petition.userId);
            formData.append("description", this.petition.description);

            if (this.files.files) {
                this.files.files.map((item, index) =>
                    formData.append("file" + index, item)
                );
            }

            const pr = Object.assign({}, petitionsRepository);
            pr.savePetition(formData)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg);
                        typeof this.onSave === "function" && this.onSave();
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error("Ocurrió un error al guardar la petición");
                });
        },
        cleanFields() {
            this.petition.description = "";
            this.petition.typePetitionId = "";
            this.files = "";
            this.$nextTick(() => {
                this.$v.$reset();
            });
            this.$bus.$emit("petition-files.clean");
        }
    },

    created() {
        this.load("petitionTypes");
        this.petition.userId = this.user.id;
        if (this.isDirector) {
            this.petition.clientId = this.clientSelected;
        } else {
            this.petition.clientId = this.client.id;
        }
        this.$bus.$on("petition-form.save", this.registerPetition);
        this.$bus.$on("petition-form.clean", this.cleanFields);
    },

    beforeDestroy() {
        this.$bus.$off("petition-form.save");
    }
};
</script>
